import go from 'gojs';
import { formatDate } from 'react-day-picker/moment';
import { getTranslate } from 'react-localize-redux';
import { _map } from '../../../../components/common/pngFlag';
import { apiGet, apiPost, getHostApi, hasPermission } from '../../../apiWrapper';
import { getType } from '../../../browserDetection';
import { SECTIONS } from '../../../reportStore';
import { isNullOrUndefined } from '../../../storeFunctions';
import { GRAPH_MODE, GRAPH_TYPE, VISIBILITY_TYPE } from '../../common/constants';
import { _handleError } from '../../common/functions';
import { _getRootElement, _insertNewLink, _isIsolated, _isRootElement, _raiseDataChanged, _removeRelationDefaultStartDate, _updateTotalNodeCount, diagramActions } from '../../diagram/actions';
import { _resetExportButtons } from '../../exports/actions';
import { leftPanelActions } from '../../leftPanel/actions';
import { _hideCommonTooltip, _showCommonTooltip, _showContextMenu, _showNodeTooltip, tooltipsActions } from '../../tooltips/actions';
import { _getGraphType, _getRelationLabelsChecked, _toggleLinkLabels } from '../../topPanel/actions';
import { diagram } from '../initial';
import { _recalculateActualRelationsCount, _reloadCounts } from '../relationCountActions';
import { _createExpandReqParams } from '../requests';
import { _collapseLevel, _expandSubTree, _hasDeletedDescendant, _setVisibility } from '../visiblityActions';

const browser = getType();

//############# node template ##############//
function createNodeTemplateMap(dispatch, getState) {
    let map = new go.Map();
    map.add('', _createEntityTemplate(go.GraphObject.make, dispatch, getState));
    map.add('merge', go.GraphObject.make(go.Node, "Auto",
        { layerName: 'merge' },
        _nodeDefaultProps(dispatch),
        new go.Binding('location', 'Location', go.Point.parse),
        new go.Binding("isShadowed", "Level", function (level) { return level === 0 ? true : false; }),
        new go.Binding("shadowColor", "", function (nodeData) { return _getNodeHeaderColor(nodeData); }),
        go.GraphObject.make(go.Panel, "Table",
            go.GraphObject.make(go.Shape, "TopButton", { width: 50, height: 50, parameter1: 2, stretch: go.GraphObject.Fill, fill: '#77777b', stroke: '#77777b' })
        )
    ));
    return map;
}

function _isSemaphoreWarning(warning) {
    return warning.StatusID === "05" || warning.StatusID === "03" || warning.StatusID === "02";
}

function _isBasicRedWarning(warning) {
    return warning.StatusID === "01" || warning.StatusID === "03" || warning.StatusID === "05";
}

function _getNodeHeaderColor(node) {
    var filtered = node.WarningShortcuts.filter(function (e) { return e.IsFiltered; });
    if (diagram.nodeDiagram.model.modelData.UseProfiWarnings) {
        if (filtered.some(_isSemaphoreWarning)) {
            return '#AF0819'; //#ef4b35 - brick-salmon
        }
    } else {
        if (filtered.some(_isBasicRedWarning))
            return '#AF0819'; //#ef4b35 - brick-salmon
    }
    switch (node.Type) {
        case "Company":
            return '#77777b';
        case "Tradesman":
            return '#023671';
        case "Address":
            return '#ee9016';
        case "Custom":
            return '#5c1b68';
        default:
            return '#71b7e6';
    }
}

function _createEntityTemplate($, dispatch, getState) {
    return $(go.Node, "Auto",
        _nodeDefaultProps(dispatch),
        new go.Binding('location', 'Location', go.Point.parse),
        new go.Binding("isShadowed", "", function (nodeData) { return _setShadowedNode(nodeData) }),
        new go.Binding("shadowColor", "", function (nodeData) { return _getNodeHeaderColor(nodeData); }),
        $(go.Shape,
            { figure: "TopButton", parameter1: 2, spot1: new go.Spot(0, 0), spot2: new go.Spot(1, 1), stretch: go.GraphObject.Fill, fill: '#eeeeee' },
            new go.Binding("stroke", "", function (nodeData) { return _getNodeHeaderColor(nodeData); })
        ),
        $(go.Panel, "Table",
            { defaultAlignment: go.Spot.Left },
            _createNodeHeaderRow($, dispatch, getState),
            _createNodeContentRow($, dispatch, getState),
            _createNodeFooterRow($, dispatch)
        ),
        new go.Binding('fromSpot', '', function (data) { return data.GraphType === GRAPH_TYPE.branch ? go.Spot.LeftRightSides : data.GraphType === GRAPH_TYPE.tree ? go.Spot.TopBottomSides : go.Spot.AllSides; }),
        new go.Binding('toSpot', '', function (data) { return data.GraphType === GRAPH_TYPE.branch ? go.Spot.LeftRightSides : data.GraphType === GRAPH_TYPE.tree ? go.Spot.TopBottomSides : go.Spot.AllSides; }),
        new go.Binding("visible", "", function (data) { return isNullOrUndefined(data.Visibility) || data.Visibility === VISIBILITY_TYPE.visible }),
    )
}

function _createNodeHeaderRow($, dispatch, getState) {
    return $(go.Panel, "TableRow",
        { stretch: go.GraphObject.Horizontal },
        new go.Binding("background", "", function (nodeData) { return _getNodeHeaderColor(nodeData); }),
        _createNodeSubjectIconPanel($),
        _createNodeButtonPanel($, dispatch, getState)
    );
}

function _createNodeSubjectIconPanel($) {
    return $(go.Panel, "Horizontal",
        { alignment: go.Spot.Left, height: 30 },
        $("Button",
            {
                "ButtonBorder.opacity": 0, click: function (e, obj) { _showSubjectIDInformation(e.event, obj.part) }, mouseEnter: function (e, obj) { }, mouseLeave: function (e, obj) { }
            },
            new go.Binding("cursor", "", function (node) { return node.Type !== "Custom" ? "pointer" : "default" }),
            $(go.Picture,
                { width: 20, height: 20, imageStretch: go.GraphObject.Fill },
                new go.Binding("source", "", function (node) { return _getNodeIconPath(node.EntityType); })
            )
        )
    );
}

function _getNodeIconPath(entityType) {
    switch (entityType) {
        case "PO": return require('../../../../img/icons/PravnickaOsoba.svg');
        case "FO": return require('../../../../img/icons/FyzickaOsoba.svg');
        case "FOP": return require('../../../../img/icons/FyzickaOsobaPodnikatel.svg');
        case "AD": return require('../../../../img/icons/Domu.svg');
        case "OT": return require('../../../../img/icons/Napoveda.svg');
        default: return require('../../../../img/icons/Napoveda.svg');
    }
}

function _createNodeButtonPanel($, dispatch, getState) {
    return $(go.Panel, "Horizontal",
        { alignment: go.Spot.Right, margin: new go.Margin(2, 2, 2, 5) },

        _createClipButton($, dispatch, getState),
        _createLockButton($, dispatch, getState),
        _createExpandButton($, dispatch, getState),
        _createLoadingCountButton($, dispatch, getState),
        _createTooManyRelationsButton($, dispatch, getState),
        _createReportButton($, dispatch)
    );
}

function _createClipButton($, dispatch, getState) {
    return $("Button",
        {
            "ButtonBorder.figure": "TopButton",
            "ButtonBorder.width": 36,
            "ButtonBorder.height": 24,
            "ButtonBorder.stroke": "transparent",
            cursor: "pointer",
            margin: new go.Margin(0, 3, 0, 0),
            click: function (e, obj) { _addToClipBoard(obj.part, getState); },
            mouseEnter: function (e) { _showCommonTooltip(getTranslate(getState().localize)('Search.Clipboard.AddTooltip'), e.event, dispatch); },
            mouseLeave: function () { _hideCommonTooltip(dispatch); }
        },
        new go.Binding("ButtonBorder.fill", "", function (nodeData) { return _getNodeButtonColor(nodeData); }),
        new go.Binding("visible", "", function (node) { return node.EntityID >= 0 && node.Type !== "Address" }),
        $(go.Picture,
            { width: 20, height: 20, imageStretch: go.GraphObject.Fill, source: require('../../../../img/icons/BBicons_Pin.svg') },
            new go.Binding("angle", "", function (node) { return _isInClipboard(node, getState) ? -45 : 0 })
        )
    );
}

function _addToClipBoard(node, getState) {
    var info = { name: node.data.Name, entityId: node.data.EntityID, dateOfBirth: node.data.DateOfBirthOrCreationDate, ico: node.data.IC };
    if (node.data.EntityType === "FO") {
        info.type = 2;
        info.reports = { AR: false };
    }
    else if (node.data.EntityType === "FOP") {
        info.type = 1;
        info.entrepreneur = true;
        info.reports = { AR: false };
    }
    else if (node.data.EntityType === "PO") {
        info.type = 1;
        info.entrepreneur = false;
        info.reports = { AR: false };
    }
    else if (node.data.EntityType === "AD") {
        info.type = 2;
        info.reports = { AR: true };
    }

    const isInClipBoard = _isInClipboard(node.data, getState)
    isInClipBoard ? diagram._removeFromClipboardFunc(info) : diagram._addToClipboardFunc(info);

    diagram.nodeDiagram.model.commit(function (m) {
        m.set(node.data, "angle", isInClipBoard ? -45 : 0);
    });
}

function _isInClipboard(data, getState) {
    if (data.EntityID < 0)
        return false;
    return getState().search.clipboard.filter(x => x.entityId === data.EntityID).length === 1;
}

function _createLockButton($, dispatch, getState) {
    return $("Button",
        {
            "ButtonBorder.figure": "TopButton",
            "ButtonBorder.width": 36,
            "ButtonBorder.height": 24,
            "ButtonBorder.stroke": "transparent",
            click: function (e, obj) {
                const node = obj.part;
                const data = node.data;
                if (data) {
                    node.diagram.startTransaction("checkedNode");
                    const old = data.IsLocked;

                    node.diagram.selection.each(function (part) {
                        if (part instanceof go.Node) {
                            part.data.IsLocked = old ? false : true;
                            part.diagram.model.raiseDataChanged(part.data, "IsLocked", old, part.data.IsLocked);
                        }
                    });

                    data.IsLocked = old ? false : true;
                    node.diagram.model.raiseDataChanged(data, "IsLocked", old, data.IsLocked);

                    node.diagram.commitTransaction("checkedNode");
                }
            },
            margin: new go.Margin(0, 3, 0, 0),
            mouseEnter: function (e) { _showCommonTooltip(getTranslate(getState().localize)('Charts.LockNodeToolTip'), e.event, dispatch); },
            mouseLeave: function () { _hideCommonTooltip(dispatch); }
        },
        new go.Binding("ButtonBorder.fill", "", function (nodeData) { return _getNodeButtonColor(nodeData); }),
        new go.Binding("visible", "Level", function (level) { return level !== 0; }),
        $(go.TextBlock,
            { cursor: "pointer", font: "24px icomoon-dv", height: 24, width: 36 },
            new go.Binding("text", "", function (node) { return String.fromCharCode(node.IsLocked ? 61540 : 61549) }),
            new go.Binding("stroke", "", function (node) { return node.IsLocked ? '#af0819' : '#3f3f3e' }),
            new go.Binding("margin", "", function (node) { return diagram._marginCorrection ? new go.Margin(19, 0, 0, 12) : new go.Margin(3, 0, 0, 12) })
        )
    );
}

function _createExpandButton($, dispatch, getState) {
    return $("Button",
        {
            "ButtonBorder.figure": "TopButton",
            "ButtonBorder.height": 24,
            "ButtonBorder.stroke": "transparent",
            minSize: new go.Size(36, 24),
            cursor: "pointer",
            margin: new go.Margin(0, 3, 0, 0),
            mouseEnter: function (e) { _showCommonTooltip(getTranslate(getState().localize)('Charts.ExpandNodeTooltip'), e.event, dispatch); },
            mouseLeave: function () { _hideCommonTooltip(dispatch); },
            shadowVisible: false,
            click: function (e, obj) {
                if (!_canShowRelationsButton(obj.part.data, getState)) return;
                if (obj.part.data.HasChildrenLoaded) {
                    _expandCollapseTree(e, obj.part, dispatch, getState);
                } else {
                    _expandNodeFromDatabase(e, obj.part, dispatch, getState, null);
                }
            }
        },
        new go.Binding("ButtonBorder.fill", "", function (nodeData) { return _getNodeButtonColor(nodeData); }),
        new go.Binding("visible", "", function (node) { return !isNullOrUndefined(node.RelationsCount) && node.RelationsCount < node.LimitRelations && node.RelationsCount > 0; }),
        $(go.TextBlock, { stroke: '#3f3f3e' },
            new go.Binding("margin", "", function (node) { return node.IsExpanded ? new go.Margin(2, 0, 0, 0) : new go.Margin(4, 3, 0, 0); }),
            new go.Binding("font", "", function (node) { return node.IsExpanded || !_canShowRelationsButton(node, getState) ? "normal 24pt Open Sans" : "bold 11pt Open Sans" }),
            new go.Binding("text", "", function (node) { return node.IsExpanded || !_canShowRelationsButton(node, getState) ? '-' : _getRelationCountIcon(node, getState); })
        )
    );
}

function _getRelationCountIcon(nodeData, getState) {
    if (nodeData.IsExpanded || !_canShowRelationsButton(nodeData, getState)) { return "-"; }
    else { return nodeData.actualRelationsCount > 0 ? `+${nodeData.actualRelationsCount}` : nodeData.actualRelationsCount }
}

function _canShowRelationsButton(node, getState) {
    var mode = getState().charts.mode;
    let max = 0;
    diagram.nodeDiagram.nodes.each(
        function (node) {
            if (node.data.Level > max) {
                max = node.data.Level;
            }
        });
    return !(mode === GRAPH_MODE.path && node.Level === max);
}

function _createLoadingCountButton($, dispatch, getState) {
    return $("Button",
        {
            "ButtonBorder.figure": "TopButton",
            "ButtonBorder.width": 36,
            "ButtonBorder.height": 24,
            "ButtonBorder.stroke": "transparent",
            "ButtonBorder.fill": "#dcdcdd",
            margin: new go.Margin(0, 3, 0, 0),
            mouseEnter: function (e) { _showCommonTooltip(getTranslate(getState().localize)('Charts.RelationCountCalculationTooltip'), e.event, dispatch); },
            mouseLeave: function () { _hideCommonTooltip(dispatch); },
            shadowVisible: false
        },
        new go.Binding("visible", "RelationsCount", function (relCount) { return isNullOrUndefined(relCount); }),
        $(go.TextBlock, { cursor: "progress", font: "24px icomoon-dv", height: 24, width: 36 },
            new go.Binding("margin", "", function (node) { return diagram._marginCorrection ? new go.Margin(19, 0, 0, 12) : new go.Margin(3, 0, 0, 12) }),
            new go.Binding("text", "", function () { return String.fromCharCode(61555); })
        )
    );
}

function _createTooManyRelationsButton($, dispatch, getState) {
    return $("Button",
        {
            "ButtonBorder.figure": "TopButton",
            "ButtonBorder.height": 24,
            "ButtonBorder.stroke": "transparent",
            "ButtonBorder.fill": "#dcdcdd",
            minSize: new go.Size(36, 24),
            cursor: "pointer",
            margin: new go.Margin(0, 3, 0, 0),
            mouseEnter: function (e, obj) { _showCommonTooltip(getTranslate(getState().localize)('Charts.TooManyRelationsTooltip').replace("{0}", obj.part.part.data.LimitRelations), e.event, dispatch); },
            mouseLeave: function () { _hideCommonTooltip(dispatch); },
            shadowVisible: false,
            click: function (e, obj) {
                if (obj.part.data.HasChildrenLoaded) {
                    _expandCollapseTree(e, obj.part, dispatch);
                } else {
                    _expandNodeFromDatabase(e, obj.part, dispatch, getState, null);
                }
            }
        },
        new go.Binding("visible", "", function (node) { return !isNullOrUndefined(node.RelationsCount) && node.RelationsCount >= node.LimitRelations; }),
        $(go.TextBlock, { stroke: '#3f3f3e' },
            new go.Binding("margin", "", function (node) { return node.IsExpanded ? new go.Margin(2, 0, 0, 0) : new go.Margin(4, 3, 0, 0); }),
            new go.Binding("font", "", function (node) { return node.IsExpanded ? "normal 24pt Open Sans" : "bold 11pt Open Sans" }),
            new go.Binding("text", "", function (node) { return node.IsExpanded ? '-' : node.LimitRelations + "+"; })
        )
    );
}

function _getNodeButtonColor(nodeData) {
    switch (nodeData.Type) {
        case "Custom": return "#d8cfda";
        default: return "#dcdcdd";
    }
}

function _createReportButton($, dispatch) {
    return $("Button",
        {
            "ButtonBorder.figure": "TopButton",
            "ButtonBorder.width": 36,
            "ButtonBorder.height": 24,
            "ButtonBorder.stroke": "transparent",
            cursor: "pointer",
            margin: new go.Margin(0, 3, 0, 0),
            click: function (e, obj) { _showContextMenu(e, obj.part, dispatch); },
            mouseEnter: function (e, obj) { },
            mouseLeave: function (e, obj) { },
            shadowVisible: false
        },
        new go.Binding("ButtonBorder.fill", "", function (nodeData) { return _getNodeButtonColor(nodeData); }),
        $(go.TextBlock,
            { font: "normal 14pt Open Sans", text: '...', margin: new go.Margin(-7, 0, 0, 0), stroke: '#3f3f3e' }
        )
    );
}

function _expandCollapseTree(e, button, dispatch, getState) {
    var node = button.part;

    if (node instanceof go.Adornment) node = node.adornedPart;
    if (!(node instanceof go.Node)) return;

    var dgrm = node.diagram;
    if (dgrm === null) return;

    if (node.data.IsExpanded) {
        _checkDeletedSubjects(node, getState, () => _expandCollapseTreeConfirmed(dgrm, node, dispatch));
    } else {
        _expandCollapseTreeConfirmed(dgrm, node, dispatch);
    }
}

// COLLAPSE CONDITIONS

function _checkDeletedSubjects(node, getState, expandCollapseFunc) {
    if (_hasDeletedDescendant(node)) {
        diagram._showWarningMessagePopupFunc(getTranslate(getState().localize)('Charts.DeletedSubjects.BranchReloadWarning'), expandCollapseFunc);
    } else {
        expandCollapseFunc();
    }
}

// COLLAPSE

function _expandCollapseTreeConfirmed(dgrm, node, dispatch) {
    dgrm.clearSelection();
    node.isSelected = true;

    if (node.data.IsExpanded) {
        _collapseLevel({ node: node }, true, null, VISIBILITY_TYPE.hidden);
        if (_isIsolated(node)) {
            _setVisibility(node, VISIBILITY_TYPE.hidden);
        }
    } else {
        _expandSubTree(node, null);
    }

    if (node.data) {
        dgrm.model.startTransaction("expandCollapseNode");
        diagram._noGraphZoom = true;
        _raiseDataChanged(node.data, "IsExpanded", !node.data.IsExpanded);
        node.invalidateConnectedLinks();
        dgrm.model.commitTransaction("expandCollapseNode");
    }

    _updateTotalNodeCount(dispatch);
    _toggleLinkLabels(_getRelationLabelsChecked());
    _recalculateActualRelationsCount(node);
    _resetExportButtons(dispatch);

    dgrm.layoutDiagram(true);
    dgrm.centerRect(node.actualBounds);
}

function _expandNodeFromDatabase(e, object, dispatch, getState, expandOnlyId) {
    const node = object.part;
    const nodeData = node.data;

    if (nodeData === null || nodeData === undefined) {
        return;
    }

    if (nodeData.OriginalLevel >= 5) {
        if (hasPermission(null, "RelationsUnlimited") === true) {
            const filterParameters = _createPaidReqParam(_getRootElement(diagram.nodeDiagram).EntityID);

            apiPost(`${getHostApi()}/api/charts/is-report-paid`, undefined, filterParameters,
                data => {
                    if (data.data === false) {
                        diagram._showRelationUnlimitedPopup(getTranslate(getState().localize)('Charts.RelationsUnlimitedMsg'), node, expandOnlyId);
                        return;
                    }
                    _showNextLevel(node, dispatch, getState, expandOnlyId);
                },
                err => {
                    _handleError('/api/charts/is-report-paid', err, getState);
                }
            );
        } else {
            diagram._showInformationMessagePopupFunc(getTranslate(getState().localize)('Charts.LevelNotAllowed') + ' 5');
            return;
        }
    } else {
        _showNextLevel(node, dispatch, getState, expandOnlyId);
    }
}

function _createPaidReqParam(rootId) {
    return Object.assign({}, diagram.diagramParams, {
        rootId: rootId
    })
}

function _showNextLevel(node, dispatch, getState, expandOnlyId) {
    diagram.nodeDiagram.clearSelection();

    const nodeData = node.data;
    const nodeRelations = [];
    const connectedLinks = node.linksConnected;
    while (connectedLinks.next()) {
        const link = connectedLinks.value.data;
        if (link.RelationsData !== null && link.RelationsData !== undefined && link.RelationsData.length > 0) {
            for (let i = 0; i < link.RelationsData.length; i++) {
                nodeRelations.push(link.RelationsData[i].RelationID);
            }
        }
    }
    const filterParameters = _createExpandReqParams(
        nodeData.EntityID,
        nodeData.OriginalLevel,
        nodeData.OrientedLevel,
        nodeRelations,
        expandOnlyId,
        _getRootElement(diagram.nodeDiagram).EntityID
    );

    diagram.nodeDiagram.model.startTransaction("expandingNode");
    dispatch({ type: diagramActions.ROOT_UPDATE, data: { loading: true } });
    apiPost(`${getHostApi()}/api/charts/expanded-node-data`, undefined, filterParameters,
        data => {
            _processExpandData(node, data.data, expandOnlyId)
            _updateTotalNodeCount(dispatch);
            _toggleLinkLabels(_getRelationLabelsChecked());
            _reloadCounts();
            _recalculateActualRelationsCount(node);
            _resetExportButtons(dispatch);
        },
        err => {
            _handleError('/api/charts/expanded-node-data error', err, getState);
        },
        _ => {
            diagram.nodeDiagram.model.commitTransaction("expandingNode");
            dispatch({ type: diagramActions.ROOT_UPDATE, data: { loading: false } })
        });
}

function _processExpandData(node, expandedNodeData, expandOnlyId) {
    const nodeData = node.data;
    expandedNodeData.Nodes.forEach(function (newNode) {
        if (expandOnlyId == null || expandOnlyId === newNode.EntityID) {
            newNode.GraphType = _getGraphType();
            newNode.Level = newNode.GraphType === GRAPH_TYPE.oriented ? newNode.OrientedLevel : newNode.OriginalLevel;
            if (diagram.nodeDiagram.model.findNodeDataForKey(newNode.EntityID) === null) {

                newNode.showFlag = nodeData.isRootForeign || (nodeData.isRootCzech && newNode.CountryCode !== "19") || (nodeData.isRootSlovak && newNode.CountryCode !== "67");
                newNode.isRootForeign = nodeData.isRootForeign;
                newNode.isRootSlovak = nodeData.isRootSlovak;
                newNode.isRootCzech = nodeData.isRootCzech;
                newNode.actualRelationsCount = 0;
                newNode.Visibility = VISIBILITY_TYPE.visible;

                diagram.nodeDiagram.model.addNodeData(newNode);
            } else {
                const node = diagram.nodeDiagram.findNodeForKey(newNode.EntityID);
                if (!node.visible) {
                    _setVisibility(node, VISIBILITY_TYPE.visible);
                }
            }
        }
    });
    expandedNodeData.Relations.forEach(function (link) {
        if (expandOnlyId == null || expandOnlyId === link.ChildID || expandOnlyId === link.ParentID) {
            // Filter default SQL date.
            _removeRelationDefaultStartDate(link);
            _insertNewLink(link);
        }
    });

    const isExpanded = expandOnlyId == null ? true : nodeData.IsExpanded;
    const hasChildrenLoaded = expandOnlyId == null ? true : nodeData.HasChildrenLoaded;

    diagram._noGraphZoom = true;
    _raiseDataChanged(nodeData, "IsExpanded", isExpanded);
    _raiseDataChanged(nodeData, "HasChildrenLoaded", hasChildrenLoaded);
    node.invalidateConnectedLinks();

    diagram.nodeDiagram.layoutDiagram(true);
    if (node.actualBounds !== undefined) //custom entity added
        diagram.nodeDiagram.centerRect(node.actualBounds);
}

function _nodeDefaultProps(dispatch) {
    return {
        selectionAdorned: true,
        selectable: true,
        selectionAdornmentTemplate: go.GraphObject.make(go.Adornment, "Auto",
            go.GraphObject.make(go.Shape, "SelectionRectangle", { fill: null, strokeWidth: 3, stroke: '#ee9016', opacity: 1 }),
            go.GraphObject.make(go.Placeholder)
        ),
        shadowBlur: 20,
        shadowOffset: new go.Point(0, 0),
        selectionChanged: (node) => _nodeSelectionChanged(node, dispatch),
        doubleClick: function (e, node) { _nodeDoubleClick(e, node, dispatch) }
    }
}

function _nodeSelectionChanged(node, dispatch) {
    if (node.isSelected) {
        // special case of a fake root node when merging subjects
        // that also selects the nodes it's directly connected with
        diagram.selectedNodes.push({ key: node.data.EntityID, val: node.data.Name });
        if (node.data.EntityID === -1) {
            node.findLinksOutOf().each(function (link) {
                link.toNode.isSelected = true;
            });
        }
    } else {
        diagram.selectedNodes = diagram.selectedNodes.filter(function (value) {
            return value.key !== node.data.EntityID;
        });
    }
    dispatch({ type: leftPanelActions.LEFT_PANEL.TOGGLE, data: { customRelationsEnabled: diagram.selectedNodes.length === 1 || diagram.selectedNodes.length === 2 } });
}

function _nodeDoubleClick(node, nodeData, dispatch) {
    if (nodeData.data.Type === "Custom") {
        apiGet(`${getHostApi()}/api/charts/custom-entity`, { entId: nodeData.data.EntityID }, data => {
            data.EntityType = nodeData.data.EntityType;
            data.Name = nodeData.data.Name;
            data.IC = nodeData.data.IC || '';
            data.DateOfBirthOrCreationDate = nodeData.data.DateOfBirthOrCreationDate ? formatDate(nodeData.data.DateOfBirthOrCreationDate, 'DD.MM.YYYY', 'cs') : null;
            data.SemaphoreCode = nodeData.data.SemaphoreCode || '';
            data.EntityID = nodeData.data.EntityID;
            data.CurrentUser = nodeData.data.UserId === diagram._currentUser.id;
            data.CurrentUserId = diagram._currentUser.id;
            diagram._showCustomEntityPopupFunc('edit', data);
        });
    }
}

function _showSubjectIDInformation(mouseEvnt, node) {
    if (node.part.data.Type === "Custom")
        return;
    var url = '';
    if (node.part.data.Type === "Address")
        url = "/unlimited/quickAddress/" + node.part.data.EntityID + `/${SECTIONS.quickAddressReport}|${SECTIONS.quickAddressReportRelations}`;
    else
        url = "/unlimited/quick/" + node.part.data.EntityID + `/${SECTIONS.quickReport}|${SECTIONS.quickReportRelations}`;
    window.open(url, "_blank", "resizable=yes, scrollbars=yes, titlebar=yes, width=800, height=900, top=10, left=10");
}


function _setShadowedNode(nodeData) {
    if (_isRootElement(nodeData.EntityID)) {
        return true;
    }
    return false;
}

function _createNodeContentRow($, dispatch, getState) {
    return $(go.Panel, "TableRow",
        {
            row: 1, stretch: go.GraphObject.Horizontal,
            width: 250,
            mouseHover: function (e, node) { _showNodeTooltip(node.part.data, e.event, dispatch); },
            mouseLeave: function () { dispatch({ type: tooltipsActions.NODE_TOOLTIP.HIDE }); }
        },
        $(go.Panel, "Horizontal",
            { stretch: go.GraphObject.Horizontal },
            _createNodeNameIdent($, getState)
        )
    );
}

function _createNodeNameIdent($, getState) {
    var browserConst = browser === "IE" || browser === "Edge" ? 18 : 0;
    return $(go.Panel, "Vertical",
        { margin: new go.Margin(5, 0, 3, 5) },
        $(go.Panel, "Horizontal",
            { alignment: go.Spot.Left, stretch: go.GraphObject.Horizontal },
            $(go.Panel, "Table",
                { defaultAlignment: go.Spot.Left, stretch: go.GraphObject.Horizontal, width: 240 },
                $(go.TextBlock,
                    { column: 0, font: "bold 14pt Open Sans", margin: 0, isMultiline: true, stroke: '#3f3f3e', shadowVisible: false },
                    new go.Binding("text", "", function (node) { return node.Type === "Address" ? node.Street : node.Name; }),
                    new go.Binding("width", "", function (node) { return node.Type !== "Person" ? 234 - browserConst : (234 - 20 - (('' + node.TotalRelationsCount).length * 12)) - browserConst; })
                ),
                $(go.TextBlock,
                    { font: "normal 12pt Open Sans", margin: new go.Margin(0, 2, 0, 0), stroke: '#3f3f3e', alignment: go.Spot.TopRight },
                    new go.Binding("text", "TotalRelationsCount", function (relations) { return (relations == null || relations <= 0) ? "" : "(+" + relations + ")"; }),
                    new go.Binding("visible", "", function (node) { return node.Type === "Person"; })
                )
            )
        ),
        $(go.Panel, "Horizontal", { alignment: go.Spot.Left, stretch: go.GraphObject.Horizontal },
            $(go.TextBlock,
                { font: "normal 12pt Open Sans", stroke: '#3f3f3e', margin: new go.Margin(3, 0, 0, 3) },
                new go.Binding("text", "", function (node) {
                    if (node.Type === "Address")
                        return node.City + ' ' + node.Zip;

                    return getTranslate(getState().localize)('Charts.PersonDateOfBirth') + ' ' + node.DateOfBirthOrCreationDateFormated;
                })
            ),
            new go.Binding("visible", "", function (node) { return node.Type === "Address" || (node.EntityType === "FO" && node.DateOfBirthOrCreationDateFormated !== null); })
        ),
        $(go.Panel, "Horizontal", { alignment: go.Spot.Left, stretch: go.GraphObject.Horizontal },
            $(go.TextBlock,
                { font: "normal 12pt Open Sans", margin: new go.Margin(3, 0, 0, 3), stroke: '#3f3f3e' },
                new go.Binding("text", "", function (data) { return getTranslate(getState().localize)('Charts.CompanyIC') + ' ' + data.IC; })
            ),
            new go.Binding("visible", "", function (data) { return (data.EntityType === "PO" || data.EntityType === "FOP") && data.IC !== null && data.IC !== ''; })
        )
    );
}

function _createNodeFooterRow($, dispatch) {
    return $(go.Panel, "Horizontal",
        { row: 2, height: 28, stretch: go.GraphObject.Fill, margin: new go.Margin(0, 1, 0, 0) },
        new go.Binding("background", "", function (node) { return _getWarningPanelBackground(node); }),
        _createNodeMainWarningSpot($, dispatch),
        _createNodeMainWarningCrown($, dispatch),
        _createNodeWarningPanel($, dispatch),
        _createNodeAdditionalInfoPanel($, dispatch),
        _createNodeFlagPanel($, dispatch)
    );
}

function _getNodeCribisSemaphoreColor(nodeData) {
    switch (nodeData.SemaphoreCode) {
        case "3":
            return "#AF0819";
        case "2":
            return "#EE9016";
        case "1":
            return "#669324";
        default:
            return "#77777B";
    }
}

function _createNodeMainWarningSpot($, dispatch) {
    return $("Button",
        {
            "ButtonBorder.figure": "TopButton",
            "ButtonBorder.width": 32,
            "ButtonBorder.height": 28,
            "ButtonBorder.stroke": "transparent",

            alignment: go.Spot.Left,
            mouseHover: function (e, node) { _showNodeTooltip(node.part.data, e.event, dispatch); },
            click: function (e, node) {
                if (node.part.data.WarningShortcuts.length > 0 && node.part.data.Type !== "Address") {
                    window.open(`/warnings/${node.part.data.EntityID}`, "_blank", "resizable=yes, scrollbars=yes, titlebar=yes, width=800, height=900, top=10, left=10");
                    return null;
                }
                else
                    return null;
            },
            mouseEnter: function (e, node) { },
            mouseLeave: function () { dispatch({ type: tooltipsActions.NODE_TOOLTIP.HIDE }); }
        },
        new go.Binding("ButtonBorder.fill", "", _getNodeCribisSemaphoreColor),
        new go.Binding("cursor", "", function (node) { return node.WarningShortcuts.length > 0 && node.Type !== "Address" ? "pointer" : "default" }),
        $(go.TextBlock,
            { stroke: "white", font: "24px icomoon-dv", height: 28, width: 32 },
            new go.Binding("text", "EntityType", function (entityType) { return entityType === "FO" ? "" : String.fromCharCode(61511) }),
            new go.Binding("margin", "", function (node) { return diagram._marginCorrection ? new go.Margin(20, 0, 0, 8) : new go.Margin(2, 0, 0, 8) })
        ),
        new go.Binding("visible", "", function (node) { return node.IsGoldenCrown == null || !hasPermission(null, "RelationChartInformationPEP") })
    );
}

function _getWarningPanelBackground(node) {
    switch (node.Type) {
        case "Company":
            return '#dcdcdd';
        case "Tradesman":
            return '#cbd3db';
        case "Custom":
            return "#d8cfda";
        default:
            return '#dbe6ed';
    }
}

function _createNodeMainWarningCrown($, dispatch) {
    return $("Button",
        {
            "ButtonBorder.figure": "TopButton",
            "ButtonBorder.width": 32,
            "ButtonBorder.height": 28,
            "ButtonBorder.stroke": "transparent",

            alignment: go.Spot.Left,
            mouseHover: function (e, node) { _showNodeTooltip(node.part.data, e.event, dispatch); },
            click: function (e, node) {
                if (node.part.data.WarningShortcuts.length > 0 && node.part.data.Type !== "Address") {
                    window.open(`/warnings/${node.part.data.EntityID}`, "_blank", "resizable=yes, scrollbars=yes, titlebar=yes, width=800, height=900, top=10, left=10");
                    return null;
                }
                else
                    return null;
            },
            mouseEnter: function (e, node) { },
            mouseLeave: function () { dispatch({ type: tooltipsActions.NODE_TOOLTIP.HIDE }); }
        },
        new go.Binding("ButtonBorder.fill", "", _getWarningPanelBackground),
        new go.Binding("cursor", "", function (node) { return node.WarningShortcuts.length > 0 && node.Type !== "Address" ? "pointer" : "default" }),
        $(go.TextBlock,
            { font: "24px icomoon-dv", height: 28, width: 32, text: String.fromCharCode(59648) },
            new go.Binding("stroke", "", function (node) { if (node.IsGoldenCrown === true) return '#ee9016'; return '#777777'; }),
            new go.Binding("margin", "", function (node) { return diagram._marginCorrection ? new go.Margin(20, 0, 0, 8) : new go.Margin(2, 0, 0, 8) })
        ),
        new go.Binding("visible", "", function (node) { return node.IsGoldenCrown != null && hasPermission(null, "RelationChartInformationPEP") })
    );
}

function _createNodeWarningPanel($, dispatch) {
    return $(go.Panel, "Auto",
        {
            alignment: go.Spot.Left,
            mouseHover: function (e, node) { _showNodeTooltip(node.part.data, e.event, dispatch); },
            mouseLeave: function () { dispatch({ type: tooltipsActions.NODE_TOOLTIP.HIDE }); }
        },
        new go.Binding("minSize", "", function (data) {
            var fullWidth = 210;
            if (data.showFlag)
                fullWidth = fullWidth - 27;
            if (data.HasAdditionalInfo)
                fullWidth = fullWidth - 17;

            return new go.Size(fullWidth, 28);
        }),
        $(go.Panel, "Horizontal",
            {
                alignment: go.Spot.Left,
                margin: new go.Margin(6, 5, 6, 5),
                click: function (e, node) {
                    if (node.part.data.Type !== "Address") {
                        window.open(`/warnings/${node.part.data.EntityID}`, "_blank", "resizable=yes, scrollbars=yes, titlebar=yes, width=800, height=900, top=10, left=10");
                        return null;
                    }
                    else
                        return null;
                },
                mouseEnter: function (e, node) { },
                mouseLeave: function (e, obj) { }
            },
            new go.Binding("cursor", "Type", function (type) {
                if (type !== "Address") {
                    return "pointer";
                } else {
                    return "default;"
                }
            }),
            new go.Binding("itemArray", "WarningOverview"),
            {
                itemTemplate:
                    $(go.Panel, "Auto",
                        { margin: new go.Margin(0, 3, 0, 0) },
                        new go.Binding("visible", "IsFiltered"),
                        $(go.Shape,
                            { figure: "WarningItem", strokeWidth: 1, margin: new go.Margin(2, 0, 2, 0) },
                            new go.Binding("fill", "UseProfiWarnings", function (w, model) { return _getNodeWarningBackground(w, model.panel.data); }).ofModel(),
                            new go.Binding("stroke", "UseProfiWarnings", function (w, model) { return _getNodeWarningBackground(w, model.panel.data); }).ofModel()
                        ),
                        $(go.TextBlock,
                            new go.Binding("text", "WarningsCode"),
                            new go.Binding("font", "UseProfiWarnings", function (w, model) { return _getNodeWarningFont(w, model.panel.data); }).ofModel(),
                            new go.Binding("stroke", "UseProfiWarnings", function (w, model) { return _getNodeWarningStroke(w, model.panel.data); }).ofModel(),
                            new go.Binding("margin", "WarningsCode", function (w, model) {
                                var noBackground = _getNodeWarningBackground(w, model.panel.data) === 'transparent';
                                if (_isActualWarning(model.panel.data)) {
                                    if (noBackground) {
                                        return w.length > 1 ? new go.Margin(1, 0, 1, 0) : new go.Margin(1, 0, 1, 0);
                                    }
                                    return w.length > 1 ? new go.Margin(1, 2, 1, 2) : new go.Margin(1, 3, 1, 3);
                                }

                                if (noBackground) {
                                    return w.length > 1 ? new go.Margin(2, 0, 2, 0) : new go.Margin(2, 0, 2, 0);
                                }
                                return w.length > 1 ? new go.Margin(2, 2, 2, 2) : new go.Margin(2, 3, 2, 3);
                            })
                        )
                    )
            }
        )
    );
}

function _getNodeWarningBackground(useProfi, target) {
    if (useProfi) {
        switch (target.StatusID) {
            case "02":
            case "03":
                return "#ee9016";
            case "05":
                return "#af0819";
            default:
                return "transparent";
        }
    }

    // basic style
    return "transparent";
}

function _getNodeWarningFont(useProfi, target) {
    if (!useProfi && (target.StatusID === "0x" || target.StatusID === "0y"))
        return "normal 14px Open Sans";
    if (useProfi && target.StatusID === "0x")
        return "normal 14px Open Sans";
    if (useProfi && target.StatusID === "0y")
        return "italic 14px Open Sans";

    return (!_isActualWarning(target) && useProfi) ? "italic 14px Open Sans" : "bold 14px Open Sans"
}

function _getNodeWarningStroke(useProfi, target) {
    if (useProfi) {
        if (target.StatusID === "0x" || target.StatusID === "0y")
            return "#6f6f6d";

        return target.StatusID === "00" || target.StatusID === "01" ? "#3f3f3e" : "#ffffff";
    }

    if (target.StatusID === "0x" || target.StatusID === "0y")
        return "#6f6f6d";

    return _isActualWarning(target) ? "#af0819" : "#3f3f3e";
}

function _isActualWarning(warning) {
    return warning.StatusID === "01" || warning.StatusID === "03" || warning.StatusID === "05" || warning.StatusID === "0x";
}

function _createNodeAdditionalInfoPanel($, dispatch) {
    return $(go.Panel, "Spot",
        {
            alignment: go.Spot.Right,
            margin: new go.Margin(5, 2, 3, 2),
            isClipping: true,
            click: function (e, node) {
                if (node.part.data.Type !== "Address") {
                    window.open(`/warnings/${node.part.data.EntityID}`, "_blank", "resizable=yes, scrollbars=yes, titlebar=yes, width=800, height=900, top=10, left=10");
                    return null;
                }
                else
                    return null;
            },
            mouseHover: function (e, node) { _showNodeTooltip(node.part.data, e.event, dispatch); },
            mouseLeave: function () { dispatch({ type: tooltipsActions.NODE_TOOLTIP.HIDE }); }
        },
        new go.Binding("cursor", "Type", function (type) { if (type !== "Address") { return "pointer"; } else { return "default"; } }),
        $(go.Shape, "TopButton", { height: 28, strokeWidth: 0 }),
        $(go.TextBlock, { margin: new go.Margin(0, 4, 0, 4), font: 'normal 14px Open Sans' },
            new go.Binding("text", "WarningInfoChar")),
        new go.Binding("visible", "HasAdditionalInfo")
    );
}

function _createNodeFlagPanel($, dispatch) {
    return $(go.Panel, "Spot",
        {
            alignment: go.Spot.Right,
            margin: new go.Margin(2, 5, 2, 1),
            isClipping: true,
            mouseHover: function (e, node) { _showCommonTooltip(node.part.data.Country, e.event, dispatch); },
            mouseLeave: function () { _hideCommonTooltip(dispatch); }
        },
        $(go.Shape, "TopButton", { width: 23, height: 15, strokeWidth: 0 }),
        $(go.Picture,
            { width: 23, height: 15, imageStretch: go.GraphObject.Fill },
            new go.Binding("source", "", function (node) { return _getNationalFlagImagePath(node) })
        ),
        new go.Binding("visible", "showFlag")
    );
}

function _getNationalFlagImagePath(nodeData, prop = "CountryCode") {
    if (nodeData[prop] === null || nodeData[prop] === "" || nodeData[prop] === "00") {
        return "";
    }
    const flagTag = _map[nodeData[prop]];
    return flagTag;
}

export { _expandNodeFromDatabase, _getNodeHeaderColor, _showNextLevel, createNodeTemplateMap };

